import React from "react";
import tomatoImg from "../assets/ads/tomotto.png";
import leafImg from "../assets/ads/image.png";

// Custom SVG Share Node Icon
const ShareIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-4 h-4 text-white"
  >
    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81a3 3 0 1 0-3-3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9a3 3 0 1 0 0 6c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65a3 3 0 1 0 3-3z" />
  </svg>
);

// Custom SVG Cloche Lid Icon for badge
const ClocheIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-4 h-4 text-[#f25e1c]"
  >
    <path d="M12 4v2" />
    <circle cx="12" cy="4" r="0.5" fill="currentColor" />
    <path d="M4 14c0-4.4 3.6-8 8-8s8 3.6 8 8" />
    <path d="M2 15h20v2H2z" />
  </svg>
);

// Chef Hat Icon for Badge Decoration
const ChefHatIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-4 h-4 text-[#f25e1c]"
  >
    <path d="M18.2 10.5C18.2 9.1 17.5 8 16.5 7.4c.5-1 .5-2.2 0-3.2C15.8 2.6 14 1.8 12.3 2.3c-1.7-.5-3.5.3-4.2 1.9-.5 1-.5 2.2 0 3.2-1 .6-1.7 1.7-1.7 3.1 0 1.9 1.5 3.4 3.4 3.4h4.4c1.9 0 3.4-1.5 3.4-3.4zM9.4 16h5.2v2H9.4v-2zm1 3.5h3.2v1.5h-3.2v-1.5z" />
  </svg>
);

// Social Media Icons
const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5 text-white">
    <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.75z" />
  </svg>
);

const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5 text-white">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5 text-white">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);

// High-Fidelity SVG Brand Logos
const BarbecueFoodLogo = () => (
  <div className="flex items-center gap-2 text-neutral-400/60 hover:text-[#e21b1b] transition-all duration-300 select-none">
    <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-10 h-10 shrink-0">
      <circle cx="50" cy="50" r="44" strokeDasharray="3 3" />
      <path d="M30 45 C30 30, 70 30, 70 45 Z" fill="currentColor" className="opacity-15" />
      <line x1="26" y1="48" x2="74" y2="48" strokeWidth="3.5" />
      <path d="M32 52 C32 68, 68 68, 68 52 Z" fill="currentColor" />
      <line x1="42" y1="68" x2="35" y2="85" strokeWidth="3" />
      <line x1="58" y1="68" x2="65" y2="85" strokeWidth="3" />
    </svg>
    <div className="flex flex-col leading-none text-left">
      <span className="text-[9px] font-bold uppercase tracking-widest text-neutral-500">BARBECUE</span>
      <span className="text-[13px] font-black uppercase tracking-tight text-[#071520] hover:text-[#e21b1b] transition-colors">FOOD</span>
    </div>
  </div>
);

const GoodRestaurantLogo = () => (
  <div className="flex items-center gap-2 text-neutral-400/60 hover:text-[#e21b1b] transition-all duration-300 select-none">
    <div className="flex -space-x-2 shrink-0">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className={`w-7 h-7 rounded-full bg-white border border-current flex items-center justify-center shadow-xs ${
            i === 2 ? "z-10 scale-110 -translate-y-0.5" : "opacity-70"
          }`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" className="w-3.5 h-3.5">
            <path d="M12 2v20 M17 5H7 M15 9H9" />
          </svg>
        </div>
      ))}
    </div>
    <div className="flex flex-col leading-none text-left">
      <span className="text-[12px] font-black uppercase tracking-widest text-[#071520] hover:text-[#e21b1b] transition-colors">GOOD</span>
      <span className="text-[8px] font-bold uppercase tracking-widest text-neutral-500">RESTAURANT</span>
    </div>
  </div>
);

const RestaurantEstdLogo = () => (
  <div className="flex items-center gap-2 text-neutral-400/60 hover:text-[#e21b1b] transition-all duration-300 select-none">
    <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="2" className="w-10 h-10 shrink-0">
      <circle cx="50" cy="50" r="42" />
      <circle cx="50" cy="50" r="36" strokeDasharray="2 2" />
      <path d="M25 50 Q35 70 50 70 Q65 70 75 50" strokeWidth="1" />
      <path d="M25 50 Q35 30 50 30 Q65 30 75 50" strokeWidth="1" />
      <text x="50" y="44" fontSize="8" fontWeight="bold" textAnchor="middle" fill="currentColor">ESTD</text>
      <text x="50" y="55" fontSize="10" fontWeight="black" textAnchor="middle" fill="currentColor">1985</text>
    </svg>
    <div className="flex flex-col leading-none text-left">
      <span className="text-[10px] font-black uppercase tracking-widest text-[#071520] hover:text-[#e21b1b] transition-colors">RESTAURANT</span>
      <span className="text-[7px] font-semibold uppercase tracking-wider text-neutral-500">PREMIUM QUALITY</span>
    </div>
  </div>
);

const BarbecueGrillsLogo = () => (
  <div className="flex items-center gap-2 text-neutral-400/60 hover:text-[#e21b1b] transition-all duration-300 select-none">
    <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="2" className="w-10 h-10 shrink-0">
      <circle cx="50" cy="50" r="44" strokeDasharray="3 3" />
      <circle cx="50" cy="50" r="38" />
      <path d="M30 70 L70 30" strokeWidth="3" strokeLinecap="round" />
      <path d="M70 70 L30 30" strokeWidth="3" strokeLinecap="round" />
      <rect x="38" y="38" width="24" height="24" rx="3" fill="white" stroke="currentColor" strokeWidth="1.8" />
      <path d="M44 50 L56 50 M50 44 L50 56" stroke="currentColor" strokeWidth="2" />
    </svg>
    <div className="flex flex-col leading-none text-left">
      <span className="text-[9px] font-bold uppercase tracking-wider text-neutral-500">BARBECUE</span>
      <span className="text-[13px] font-black uppercase tracking-tight text-[#071520] hover:text-[#e21b1b] transition-colors">GRILLS</span>
      <span className="text-[6px] font-bold uppercase tracking-widest text-neutral-400">INTERNATIONAL FOOD</span>
    </div>
  </div>
);

const SinceRestaurantLogo = () => (
  <div className="flex items-center gap-2 text-neutral-400/60 hover:text-[#e21b1b] transition-all duration-300 select-none">
    <svg viewBox="0 0 120 50" fill="none" stroke="currentColor" className="w-20 h-10 shrink-0">
      <path d="M10 25 C15 15, 20 12, 25 12 C30 12, 32 16, 28 22 C25 26, 20 32, 25 32 C30 32, 35 25, 38 20" strokeWidth="1.8" strokeLinecap="round" />
      <text x="65" y="24" fontSize="11" fontWeight="bold" fontStyle="italic" fill="currentColor" stroke="none">Since 1786</text>
      <text x="60" y="42" fontSize="13" fontWeight="black" letterSpacing="1" textAnchor="middle" fill="currentColor" stroke="none">RESTAURANT</text>
    </svg>
  </div>
);

// Custom Pizza outline doodle for background
const PizzaDoodle = () => (
  <svg
    viewBox="0 0 100 100"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    className="w-48 h-48 text-[#1a0e05]/[0.03] pointer-events-none select-none rotate-12"
  >
    <path d="M20 20 L80 32 L46 84 Z" />
    <path d="M20 20 C35 22, 65 26, 80 32" strokeWidth="2" />
    <circle cx="42" cy="40" r="5" />
    <circle cx="58" cy="48" r="6" />
    <circle cx="45" cy="62" r="4.5" />
    <path d="M30 35 Q38 38 40 44" />
    <path d="M62 40 Q54 44 56 50" />
  </svg>
);

const ExpertChefs = () => {
  const chefs = [
    {
      id: 1,
      name: "Ralph Edwards",
      role: "Chef Lead",
      color: "#e21b1b",
      imgUrl: "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=450&auto=format&fit=crop&q=80",
    },
    {
      id: 2,
      name: "Leslie Alexander",
      role: "Chef Assistant",
      color: "#f25e1c",
      imgUrl: "https://images.unsplash.com/photo-1581299894007-aaa50297cf16?w=450&auto=format&fit=crop&q=80",
    },
    {
      id: 3,
      name: "Ronald Richards",
      role: "Chef Assistant",
      color: "#e21b1b",
      imgUrl: "https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?w=450&auto=format&fit=crop&q=80",
    }
  ];

  const brandLogos = [
    BarbecueFoodLogo,
    GoodRestaurantLogo,
    RestaurantEstdLogo,
    BarbecueGrillsLogo,
    SinceRestaurantLogo,
    BarbecueFoodLogo,
    GoodRestaurantLogo,
    RestaurantEstdLogo,
    BarbecueGrillsLogo,
    SinceRestaurantLogo,
  ];

  return (
    <section className="relative w-full bg-[#faf8f5] pt-24 pb-20 px-6 overflow-hidden select-none">
      
      {/* Inline styles for brand marquee ticker & floating animations */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes brand-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes float-tomato {
          0%, 100% { transform: translateY(0) rotate(12deg) scale(1); }
          50% { transform: translateY(-7px) rotate(15deg) scale(1.03); }
        }
        .animate-brand-marquee {
          display: flex;
          width: max-content;
          animation: brand-marquee 30s linear infinite;
        }
        .group-hover-pause:hover .animate-brand-marquee {
          animation-play-state: paused;
        }
        .animate-float-tomato {
          animation: float-tomato 6s infinite ease-in-out;
        }
      `,
        }}
      />

      {/* Floating tomato & basil leaf top-left */}
      <div className="absolute top-8 left-8 w-24 md:w-32 pointer-events-none select-none z-10 animate-float-tomato hidden sm:block">
        <div className="relative">
          <img
            src={tomatoImg}
            alt="Tomato slice decoration"
            className="w-16 md:w-20 h-auto object-contain drop-shadow-md rotate-[12deg]"
          />
          <img
            src={leafImg}
            alt="Basil leaf decoration"
            className="absolute top-[-8px] right-[-10px] w-12 md:w-16 h-auto object-contain -rotate-[35deg] opacity-90"
          />
        </div>
      </div>

      {/* Background Pizza Doodle bottom-right */}
      <div className="absolute right-[-40px] bottom-[-40px] z-0 opacity-40 pointer-events-none hidden md:block">
        <PizzaDoodle />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        
        {/* Section Header */}
        <div className="flex flex-col items-center text-center mb-16">
          <div className="inline-flex items-center gap-2.5 bg-orange-50 px-4 py-1.5 rounded-full border border-orange-100/80 mb-3 shadow-xs">
            <ChefHatIcon />
            <span className="text-[#f25e1c] font-black tracking-widest text-[11px] uppercase font-mono">
              OUR CHEFE
            </span>
            <ChefHatIcon />
          </div>
          <h2 className="text-3xl md:text-[40px] font-extrabold text-[#071520] tracking-tight leading-tight font-sans">
            Meet Our Expert Chefe
          </h2>
        </div>

        {/* Chefs Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-items-center mb-24">
          {chefs.map((chef) => (
            <div
              key={chef.id}
              className="bg-white px-5 pt-5 pb-6 shadow-[0_8px_30px_rgba(0,0,0,0.02)] border border-neutral-100/50 w-full max-w-[325px] flex flex-col items-center group transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(7,21,32,0.06)]"
              style={{ borderRadius: "150px 150px 16px 16px" }}
            >
              {/* Double Dome Image Container */}
              <div
                className="relative w-full aspect-[4/5] overflow-hidden mb-6 flex justify-center items-end bg-neutral-100"
                style={{
                  borderRadius: "130px 130px 100px 100px / 130px 130px 35px 35px",
                  borderBottom: `6px solid ${chef.color}`
                }}
              >
                <img
                  src={chef.imgUrl}
                  alt={chef.name}
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  loading="lazy"
                />

                {/* Staggered Social Share Tray (pop up above the share button) */}
                <div className="absolute bottom-[44px] left-1/2 -translate-x-1/2 flex flex-col gap-2 items-center pointer-events-none z-30">
                  <a
                    href="#facebook"
                    className="w-8 h-8 rounded-full bg-[#f25e1c] hover:bg-[#e21b1b] text-white flex items-center justify-center shadow-md transition-all duration-300 opacity-0 scale-75 translate-y-6 pointer-events-none group-hover:opacity-100 group-hover:scale-100 group-hover:translate-y-0 group-hover:pointer-events-auto delay-75"
                    aria-label={`${chef.name}'s Facebook`}
                  >
                    <FacebookIcon />
                  </a>
                  <a
                    href="#twitter"
                    className="w-8 h-8 rounded-full bg-[#f25e1c] hover:bg-[#e21b1b] text-white flex items-center justify-center shadow-md transition-all duration-300 opacity-0 scale-75 translate-y-6 pointer-events-none group-hover:opacity-100 group-hover:scale-100 group-hover:translate-y-0 group-hover:pointer-events-auto delay-150"
                    aria-label={`${chef.name}'s Twitter`}
                  >
                    <TwitterIcon />
                  </a>
                  <a
                    href="#instagram"
                    className="w-8 h-8 rounded-full bg-[#f25e1c] hover:bg-[#e21b1b] text-white flex items-center justify-center shadow-md transition-all duration-300 opacity-0 scale-75 translate-y-6 pointer-events-none group-hover:opacity-100 group-hover:scale-100 group-hover:translate-y-0 group-hover:pointer-events-auto delay-225"
                    aria-label={`${chef.name}'s Instagram`}
                  >
                    <InstagramIcon />
                  </a>
                </div>

                {/* Floating Share Icon */}
                <button
                  aria-label={`Share ${chef.name}'s profile`}
                  className="absolute bottom-[-18px] left-1/2 -translate-x-1/2 bg-[#f25e1c] hover:bg-[#e21b1b] active:scale-95 w-9 h-9 rounded-full flex items-center justify-center shadow-md transition-all duration-500 z-20 cursor-pointer group-hover:rotate-[360deg]"
                >
                  <ShareIcon />
                </button>
              </div>

              {/* Chef Details */}
              <div className="text-center pt-2">
                <h3 className="text-lg md:text-xl font-extrabold text-[#071520] font-sans tracking-tight mb-1 group-hover:text-[#e21b1b] transition-colors duration-300">
                  {chef.name}
                </h3>
                <span className="text-xs md:text-sm font-semibold text-neutral-400 font-sans">
                  {chef.role}
                </span>
              </div>

            </div>
          ))}
        </div>

        {/* Brand Logos Ticker (Bottom of Section) */}
        <div className="w-full border-t border-neutral-200/40 pt-14 overflow-hidden flex items-center group/ticker">
          <div className="animate-brand-marquee flex items-center gap-16 md:gap-24">
            {brandLogos.map((LogoComponent, index) => (
              <div key={index} className="flex-shrink-0 cursor-pointer">
                <LogoComponent />
              </div>
            ))}
          </div>
        </div>

      </div>

    </section>
  );
};

export default ExpertChefs;
